export class Filter {
  constructor(
    public name: string,
    public selected: boolean = false,
    public display: boolean = true,
    public label?: string,
    public tooltip?: string,
    public excluded?: boolean
  ) {}
}
